// extracted by mini-css-extract-plugin
export default {"modal":"MyModal_modal__ILMDc","active":"MyModal_active__cOKXw","content":"MyModal_content__77TSy"};